export var randomNumberGenerator = function (min, max) { return Math.random() * (max - min) + min; };
//# sourceMappingURL=numberGenerator.js.map